import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import Backend from "i18next-http-backend"
import translationEn from "./translation.en"
import translationKo from "./translation.ko"

const resources = {
  en: { translation: translationEn },
  ko: { translation: translationKo },
}
const lng = "ko"
const fallbackLng = "ko"
const debug = false
const keySeparator = false
const interpolation = {
  escapeValue: false,
}

i18n.use(initReactI18next).use(Backend).use(LanguageDetector).init({
  resources,
  lng,
  fallbackLng,
  debug,
  keySeparator,
  interpolation,
})

export default i18n
